export enum FormSummaryMode {
    Standard = 'Standard',
    Alternative = 'Alternative',
}
